import React, { useEffect, useState } from 'react';
import SearchNextEvents from '../../../icsc-app/js/components/searches/SearchNextEvents/index.js';
import ErrorHandler from '../../../icsc-app/js/components/_molecules/ErrorHandler';
import client from "@general/graphql/client";
import { QueryClientProvider, QueryClient } from 'react-query';
import { ApolloProvider } from '@apollo/client';
import EditProfilePictureLink from "../../../icsc-app/js/components/_molecules/EditProfilePictureLink";

if (window.aa) {
    window.aa('init', {
        appId: process.env.ALGOLIA_APP_ID,
        apiKey: process.env.ALGOLIA_API_KEY,
    });
}

const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            // for dev - allows for errors to resolve instead of retrying
            retry: process.env.NODE_ENV === 'production',
            refetchOnWindowFocus: process.env.NODE_ENV === 'production',
        },
    },
});

const SearchUpcomingEvents = () => {
    return (
        <ErrorHandler>
            <ApolloProvider client={client}>
                <QueryClientProvider client={queryClient}>
                    <SearchNextEvents />
                </QueryClientProvider>
            </ApolloProvider>
        </ErrorHandler>
    );
};

export default SearchUpcomingEvents;
